import { useQuery } from "@tanstack/react-query";
import { useAxios } from "@/app/providers/AxiosProvider";

export default function useFloatNames() {
  const api = useAxios();

  const { data } = useQuery({
    queryKey: ["float-names"],
    queryFn: () => api.get("/floats/names"),
    staleTime: 5 * 60 * 1000,
    throwOnError: false,
  });

  return { names: data?.data ?? [] };
}
